import { Component, Input, OnInit } from '@angular/core';
import {Sort} from '@angular/material/sort';

@Component({
  selector: 'app-accordion-plus-checkbox',
  templateUrl: './accordion-plus-checkbox.component.html',
  styleUrls: ['./accordion-plus-checkbox.component.scss']
})
export class AccordionPlusCheckboxComponent implements OnInit {

  panelOpenState = false;
  test: any;
  sortedData: any;
  name: any;

 
  constructor() { 
    console.log(this.model);
  }

  model: string;
  
  @Input() 
  dataAccordion(dataAccordion: any) {
    this.model = dataAccordion;
    console.log(this.model);
    this.sortedData = dataAccordion.slice();
  }



  async ngOnInit() {
  }

  sortData(sort: Sort) {
    console.log('Imprimindo dados');
    const data = this.sortedData.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      if (sort.active) {
        return this.compare(a.name, b.name, isAsc);

      }
    });
  }
  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }


}
